module.exports = __webpack_public_path__ + "assets/13ad70b13228c183084f925e16a913c4.png";